import React, { useEffect, useState } from 'react';

import {
  subscribeLoader,
  dismissWarning,
} from './loaderService';

import './GlobalLoader.css';

const GlobalLoader = () => {
  const [state, setState] = useState({
    activeRequests: 0,
    visible: false,
    warningVisible: false,
    warningType: null,
  });

  useEffect(() => {
    return subscribeLoader((newState) => {
      setState(newState);
    });
  }, []);

  if (!state.visible) {
    return null;
  }

  const handleWait = () => {
    dismissWarning();
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleHome = () => {
    window.location.href = '/';
  };

  const isSlowWarning = state.warningType === 'slow';
  const isNetworkWarning = state.warningType === 'network';

  return (
    <div
      className={`global-loader ${
        state.warningVisible
          ? 'global-loader--warning'
          : ''
      }`}
    >
      <div className="global-loader__backdrop" />

      <div className="global-loader__box">

        {!state.warningVisible && (
          <>
            <div className="global-loader__orb">
              <div className="global-loader__ring global-loader__ring--1" />
              <div className="global-loader__ring global-loader__ring--2" />
              <div className="global-loader__core" />
            </div>

            <div className="global-loader__text">
              Загрузка
              <span className="global-loader__dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            </div>
          </>
        )}

        {state.warningVisible && isSlowWarning && (
          <>
            <div className="global-loader__warning-icon">
              !
            </div>

            <div className="global-loader__warning-title">
              Сервер отвечает слишком долго
            </div>

            <div className="global-loader__warning-text">
              Запрос ещё выполняется. Возможно,
              сервер занят или соединение нестабильно.
              <br />
              Можно дождаться ответа или выполнить
              одно из следующих действий.
            </div>

            <div className="global-loader__actions">

              <button
                type="button"
                className="global-loader__button global-loader__button--primary"
                onClick={handleWait}
              >
                Дождаться ответа
              </button>

              <button
                type="button"
                className="global-loader__button global-loader__button--secondary"
                onClick={handleReload}
              >
                Обновить страницу
              </button>

              <button
                type="button"
                className="global-loader__button global-loader__button--ghost"
                onClick={handleHome}
              >
                На главную
              </button>

            </div>
          </>
        )}

        {state.warningVisible && isNetworkWarning && (
          <>
            <div className="global-loader__warning-icon">
              !
            </div>

            <div className="global-loader__warning-title">
              Нет связи с сервером
            </div>

            <div className="global-loader__warning-text">
              Не удалось подключиться к серверу.
              <br />
              Проверьте соединение или попробуйте
              повторить запрос позже.
            </div>

            <div className="global-loader__actions">

              <button
                type="button"
                className="global-loader__button global-loader__button--primary"
                onClick={handleReload}
              >
                Попробовать снова
              </button>

              <button
                type="button"
                className="global-loader__button global-loader__button--secondary"
                onClick={handleHome}
              >
                На главную
              </button>

            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default GlobalLoader;